import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// CRITICAL: Validate config before initializing
console.log('🔥 Firebase Config Validation:', {
  apiKey: firebaseConfig.apiKey ? '✅ Loaded' : '❌ MISSING',
  authDomain: firebaseConfig.authDomain ? '✅ Loaded' : '❌ MISSING',
  projectId: firebaseConfig.projectId ? '✅ Loaded' : '❌ MISSING',
});

if (!firebaseConfig.apiKey || !firebaseConfig.projectId || !firebaseConfig.authDomain) {
  console.error('❌ CRITICAL ERROR: Firebase environment variables not loaded!');
  console.error('Check that .env file exists in /web/ directory');
  console.error('Available env vars:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP_')));
  throw new Error('Firebase configuration failed - environment variables not loaded');
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Expose auth globally for debugging
if (typeof window !== 'undefined') {
  window.firebaseAuth = auth;
  console.log('✅ Firebase Auth initialized successfully');
}

export default firebaseConfig;